import api from './api';

const accountSyncTemplatesService = {
    getTasks: async (accountId, templateId) => {
        const response = await api.get(`/accountsynctemplates/${accountId}/${templateId}`);
        return response.data;
    },

    saveTasks: async (accountId, templateId, tasks) => {
        const response = await api.post(`/accountsynctemplates/${accountId}/${templateId}`, { tasks });
        return response.data;
    },
};

export default accountSyncTemplatesService;
